import React, {useRef} from "react";
import {Button} from "./helpers/commonUi";
import {getAxiosInstance} from "./helpers/axois";
import {useToast, addToast} from './context/ToastContext'

export interface IProps {
  from: string;
  token?: string;
  collection: any;
  setDocuments: (endpoint: string, isFlush?: boolean) => void;
}

interface Error {
  code?: string;
  message?: string | any[];
}

const ImportDocument = (props: IProps) => {
  const {dispatch: toastDispatch} = useToast();
  const {from, collection, token, setDocuments} = props;
  const {collectionName, appId, versionCode} = collection;
  const inputEl = useRef<HTMLInputElement>(null);
  const Http = getAxiosInstance(from, token);

  const resetInput = () => {
    if (inputEl && inputEl.current) {
      inputEl.current.value = "";
    }
  };

  const handleInputTrigger = () => {
    if (inputEl && inputEl.current) {
      inputEl.current.click();
    }
  };

  const getErrorMessage = (error: Error): string => {
    let errorMessage = "Failed to import data";

    if (error.code && typeof error.message === "string") {
      errorMessage = `${error.code}: ${error.message}`
    }

    if (error.code && Array.isArray(error.message)) {
      errorMessage = `${error.code}: ${error.message[0].message}`
    }

    return errorMessage;
  }

  const handleInputChange = async (e: any) => {
    const baseEndpoint = `a8flow/data/collections/${collectionName}`

    const formData = new FormData();
    formData.append("source", e.target.files[0]);
    formData.append("appId", appId);
    formData.append("versionCode", versionCode);
    formData.append("purgeExist", "false");
    Http.post(`${baseEndpoint}/import`, formData, {
      headers: {"Content-Type": "multipart/form-data"}
    }).subscribe(
      (_res) => {
        setDocuments(`${baseEndpoint}?appId=${appId}&versionCode=${versionCode}`, true);
        toastDispatch(addToast("Data imported successfully", "success"));
        resetInput();
      },
      (err) => {
        const errorMessage = getErrorMessage(err)
        toastDispatch(addToast(errorMessage, "error"))
        resetInput();
      }
    );
  };

  return (
    <React.Fragment>
      <input
        style={{display: "none"}}
        ref={inputEl}
        type="file"
        onChange={handleInputChange}
        accept=".json, .csv"
      />
      <Button
        disabled={!Object.keys(collection).length}
        from={from}
        color="primary"
        size="extra-small"
        onClick={handleInputTrigger}
      >
        IMPORT
      </Button>
    </React.Fragment>
  );
};

export default ImportDocument;
